import React from 'react';
import FilterList from '../../../components/user/batch/batchFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const BatchListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

BatchListPage.propTypes = {};

export default BatchListPage;
